import React, { useState } from "react";
import PropTypes from "prop-types";
import { NeoSideMenu, NeoSearch } from "../../../../components/Common";
import { GLOBAL_STATUS } from "../../../../constants/common";

/**
 * BankAccountSidebar
 * Componente de barra lateral para Contas Bancárias (Bancos e Caixas).
 * Migrado para o NeoSideMenu do Neo Design System.
 */
const BankAccountSidebar = ({ accounts = [], activeId, onSelect, onCreateNew, loading }) => {
    const [searchQuery, setSearchQuery] = useState("");

    // Filtrar contas bancárias com base na pesquisa local
    const filteredAccounts = accounts.filter((acc) => {
        const description = acc.description || "";
        const bankName = acc.bankName || "";
        return (
            description.toLowerCase().includes(searchQuery.toLowerCase()) ||
            bankName.toLowerCase().includes(searchQuery.toLowerCase())
        );
    });

    // Mapear contas bancárias para o formato NeoSideMenu
    const sideMenuItems = filteredAccounts.map((acc) => {
        const label = acc.description || "Conta";
        
        let badge = null;
        let badgeVariant = null;
        if (acc.status !== GLOBAL_STATUS.ACTIVE) {
            badge = "Inativo";
            badgeVariant = "muted";
        }

        // Descrição contendo Banco e Tipo de Conta
        const description = acc.bankName
            ? `${acc.bankName} • ${acc.accountType || ""}`
            : acc.accountType || "Conta Bancária";

        return {
            id: acc.id,
            label,
            description,
            icon: "mdi-bank-outline",
            badge,
            badgeVariant
        };
    });

    return (
        <NeoSideMenu
            title="Contas Bancárias"
            subtitle={`${accounts.length} cadastradas`}
            icon="mdi-bank"
            loading={loading}
            items={sideMenuItems}
            activeId={activeId}
            onSelect={(id) => {
                const acc = accounts.find((a) => a.id === id);
                if (acc) onSelect(acc);
            }}
            onAdd={onCreateNew}
            searchComponent={
                <NeoSearch
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Buscar conta..."
                />
            }
        />
    );
};

BankAccountSidebar.propTypes = {
    accounts: PropTypes.array.isRequired,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default BankAccountSidebar;
